import React, { useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Bar } from 'react-chartjs-2'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  makeStyles,
  colors,
} from '@material-ui/core'
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
// import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import {
  useDispatch,
  useSelector,
} from 'react-redux'
import moment from 'moment-jalaali'
import {
  getRecentlyRegistered,
  selectorRecentlyRegistered,
} from '../../../app/slices/dashboardSlice'

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: '20px',
  },
}))

const Sales = ({ className, ...rest }) => {
  const classes = useStyles()
  const theme = useTheme()
  const dispatch = useDispatch()
  const recentlyRegistered = useSelector(selectorRecentlyRegistered)

  useEffect(() => {
    dispatch(getRecentlyRegistered())
  }, [])

  console.log('recentlyRegistered', recentlyRegistered)
  const recentlyRegisteredCount = recentlyRegistered?.map((item) => item?.count)
  const recentlyRegisteredIndex = recentlyRegistered?.map((item) => moment(item?.date)?.format('jYYYY/jMM/jDD'))
  // const recentlyRegisteredIndex = recentlyRegistered?.map((item, index) => index + 1)
  console.log('recentlyRegisteredCount', recentlyRegisteredCount)

  const data = {
    datasets: [
      {
        backgroundColor: colors.indigo[500],
        data: recentlyRegisteredCount,
        label: 'تعداد',
      },
      // {
      //   backgroundColor: colors.grey[200],
      //   data: [11, 20, 12, 29, 30, 25, 13],
      //   label: 'پارسال',
      // },
    ],
    labels: recentlyRegisteredIndex,
  }

  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          barThickness: 15,
          maxBarThickness: 50,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            fontColor: theme.palette.text.secondary,
          },
          gridLines: {
            display: false,
            drawBorder: false,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0,
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider,
          },
        },
      ],
    },
    tooltips: {
      backgroundColor: theme.palette.background.default,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary,
    },
  }

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader
        action={(
          <Button
            // endIcon={<ArrowDropDownIcon />}
            size="small"
            variant="text"
          >
            ۷ روز گذشته
          </Button>
        )}
        title="ثبت نام جدید"
      />
      <Divider />
      <CardContent>
        <Box
          height={400}
          position="relative"
        >
          <Bar
            data={data}
            options={options}
          />
        </Box>
      </CardContent>
      <Divider />
      <Box
        display="flex"
        justifyContent="flex-end"
        p={2}
      >
        <Button
          color="primary"
          // endIcon={<ArrowRightIcon />}
          size="small"
          variant="text"
        >
          بررسی
        </Button>
      </Box>
    </Card>
  )
}

Sales.propTypes = {
  className: PropTypes.string,
}

export default Sales
